import * as React from 'react';
import './StatementTable.scss';
import MonthlyStatementModel, {
  IStatementData
} from 'src/model/monthlyStatement.model';
import LocaleFormating from 'src/translation/localeFormating';
import EmptyStatement from '../EmptyStatement';
import Accordion from 'src/components/common/Accordion';
import Loader from 'src/components/common/Loader';
import CustomPaginator from 'src/components/common/CustomPaginator';

export interface IStatementTableProps {
  data: IStatementData[];
  t?: any;
  pagination?: IPagination;
  handlePageSizeChange?(event: any): void;
  handleDesktopPagination?(event: any): void;
}

export interface IPagination {
  data?: any;
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
}

let t: any;

const numberFormat = (value: number) => {
  return value
    ? LocaleFormating.formatCurrency(parseFloat(value.toString()))
    : LocaleFormating.formatCurrency(0.0);
};

const renderHeaders = () => {
  return (
    <div className="rp-ms-statement-table-header-container">
      <p
        className={`rp-ms-statement-table--header-title rp-ms-statement-table-column-widht-10`}
      >
        {t('accountMonthlyStatements.invoiceDate')}
      </p>
      <p
        className={`rp-ms-statement-table--header-title rp-ms-statement-table-column-widht-10`}
      >
        {t('accountMonthlyStatements.invoiceTag')}
      </p>
      <p
        className={`rp-ms-statement-table--header-title rp-ms-statement-table-column-widht-10`}
      >
        {t('accountMonthlyStatements.dueDate')}
      </p>
      <p
        className={`rp-ms-statement-table--header-title rp-ms-statement-table-column-widht-10`}
      >
        {t('accountMonthlyStatements.customerPo')}
      </p>
      <p
        className={`rp-ms-statement-table--header-title rp-ms-statement-table-column-widht-12`}
      >
        {t('common.amount')}
      </p>
      <p
        className={`rp-ms-statement-table--header-title rp-ms-statement-table-column-widht-12`}
      >
        {t('accountMonthlyStatements.current')}
      </p>
      <p
        className={`rp-ms-statement-table--header-title rp-ms-statement-table-column-widht-12`}
      >
        <p>{t('common.pastDue')}</p>
        <p>{t('accountMonthlyStatements.pastDuethirty')}</p>
      </p>
      <p
        className={`rp-ms-statement-table--header-title rp-ms-statement-table-column-widht-12`}
      >
        <p>{t('common.pastDue')}</p>
        <p>{t('accountMonthlyStatements.pastDueSixty')}</p>
      </p>
      <p
        className={`rp-ms-statement-table--header-title rp-ms-statement-table-column-widht-12`}
      >
        <p>{t('common.pastDue')}</p>
        <p>{t('accountMonthlyStatements.pastDueSixtyPlus')}</p>
      </p>
    </div>
  );
};

const renderData = (data: IStatementData[]) => {
  const items: JSX.Element[] = [];
  data.map((item: IStatementData, idx: number) => {
    items.push(
      <div key={idx} className="rp-ms-statement-table--info-row">
        <p className="rp-ms-statement-table--info-data rp-ms-statement-table-column-widht-10">
          {item.invoiceDate}
        </p>
        <p className="rp-ms-statement-table--info-data rp-ms-statement-table-column-widht-10">
          {item.invoiceNumber}
        </p>
        <p className="rp-ms-statement-table--info-data rp-ms-statement-table-column-widht-10">
          {item.dueDate}
        </p>
        <p className="rp-ms-statement-table--info-data rp-ms-statement-table-column-widht-10">
          {item.customerPO}
        </p>
        <p className="rp-ms-statement-table--info-data rp-ms-statement-table-column-widht-12">
          {numberFormat(item.amount)}
        </p>
        <p className="rp-ms-statement-table--info-data rp-ms-statement-table-column-widht-12">
          {numberFormat(item.current)}
        </p>
        <p className="rp-ms-statement-table--info-data rp-ms-statement-table-column-widht-12">
          {numberFormat(item.firstMonthPastDueAmount)}
        </p>
        <p className="rp-ms-statement-table--info-data rp-ms-statement-table-column-widht-12">
          {numberFormat(item.secondMonthPastDueAmount)}
        </p>
        <p className="rp-ms-statement-table--info-data rp-ms-statement-table-column-widht-12">
          {numberFormat(item.thirdMonthPastDueAmount)}
        </p>
      </div>
    );
  });
  return items;
};

const renderTable = (data: IStatementData[]) => {
  if (!data || (data && data.length === 0)) {
    return (
      <div className="rp-ms-statement-table-empty">
        <EmptyStatement />
      </div>
    );
  } else {
    return (
      <div className={`rp-ms-statement-table-info-container`}>
        {renderData(data)}
      </div>
    );
  }
};

const Section = (props: {
  identifier: number;
  header: any;
  children?: any;
}) => {
  return <div>{props.children}</div>;
};

const SectionHeader = (props: {
  invoiceDate: string;
  invoiceNumber: number;
  dueDate: string;
  amount: number;
}) => {
  return (
    <div className="rp-statement-table-section-header">
      <div
        className="rp-statement-table-section-header--field"
        key={props.invoiceNumber}
      >
        <p className="rp-section-header--mobile-title">
          {t('accountMonthlyStatements.invoiceDate')}
        </p>
      </div>
      <div className="rp-statement-table-section-header--data">
        <p>{props.invoiceDate}</p>
      </div>
      <div
        className="rp-statement-table-section-header--field"
        key={props.invoiceNumber}
      >
        <p className="rp-section-header--mobile-title">
          {t('accountMonthlyStatements.invoiceTag')}
        </p>
      </div>
      <div className="rp-statement-table-section-header--data">
        <p>{props.invoiceNumber}</p>
      </div>
      <div
        className="rp-statement-table-section-header--field"
        key={props.invoiceNumber}
      >
        <p className="rp-section-header--mobile-title">
          {t('accountMonthlyStatements.dueDate')}
        </p>
      </div>
      <div className="rp-statement-table-section-header--data">
        <p>{props.dueDate}</p>
      </div>
      <div
        className="rp-statement-table-section-header--field"
        key={props.invoiceNumber}
      >
        <p className="rp-section-header--mobile-title">{t('common.amount')}</p>
      </div>
      <div className="rp-statement-table-section-header--data">
        <p>{numberFormat(props.amount)}</p>
      </div>
    </div>
  );
};

const StatementTableSectionExpandable = (props: {
  customerPO: string;
  current: number;
  firstMonthPastDueAmount: number;
  secondMonthPastDueAmount: number;
  thirdMonthPastDueAmount: number;
  invoiceNumber: number;
}) => {
  return (
    <div className="rp-section-header--expanded">
      <div
        className="rp-section-header--expanded-field"
        key={props.invoiceNumber}
      >
        <p className="rp-section-header--mobile-title">
          {t('accountMonthlyStatements.customerPo')}
        </p>
      </div>
      <div className="rp-section-header--expanded-data">
        <p>{props.customerPO ? props.customerPO : '...'}</p>
      </div>
      <div
        className="rp-section-header--expanded-field"
        key={props.invoiceNumber}
      >
        <p className="rp-section-header--mobile-title">
          {t('accountMonthlyStatements.current')}
        </p>
      </div>
      <div className="rp-section-header--expanded-data">
        <p>{numberFormat(props.current)}</p>
      </div>
      <div
        className="rp-section-header--expanded-field"
        key={props.invoiceNumber}
      >
        <p className="rp-section-header--mobile-title">
          {t('common.pastDue')} {t('accountMonthlyStatements.pastDuethirty')}
        </p>
      </div>
      <div className="rp-section-header--expanded-data">
        <p>{numberFormat(props.firstMonthPastDueAmount)}</p>
      </div>
      <div
        className="rp-section-header--expanded-field"
        key={props.invoiceNumber}
      >
        <p className="rp-section-header--mobile-title">
          {t('common.pastDue')} {t('accountMonthlyStatements.pastDueSixty')}
        </p>
      </div>
      <div className="rp-section-header--expanded-data">
        <p>{numberFormat(props.secondMonthPastDueAmount)}</p>
      </div>
      <div
        className="rp-section-header--expanded-field"
        key={props.invoiceNumber}
      >
        <p className="rp-section-header--mobile-title">
          {t('common.pastDue')} {t('accountMonthlyStatements.pastDueSixtyPlus')}
        </p>
      </div>
      <div className="rp-section-header--expanded-data">
        <p>{numberFormat(props.thirdMonthPastDueAmount)}</p>
      </div>
    </div>
  );
};

const StatementTable: React.SFC<IStatementTableProps> = props => {
  t = props.t;
  const { pagination } = props;
  return (
    <div className="rp-ms-statement-table--container">
      <div className="rp-statement-table-title-conatainer">
        <div className="rp-ms-statement-table-title">
          {t('accountMonthlyStatements.monthlyStatementTableTxt')}{' '}
        </div>
        <div className="rp-product-statement--paginator">
          <CustomPaginator
            activePage={pagination.pageNumber ? pagination.pageNumber + 1 : 1}
            totalPages={pagination.totalPages}
            itemsPerPage={pagination.pageSize}
            onPageChanged={props.handleDesktopPagination}
            totalItems={pagination.totalPages * pagination.pageSize}
            showPageInfo={true}
            onPageSizeChange={props.handlePageSizeChange}
            showPageRangeChange={true}
            currentPageSize={pagination.pageSize}
          />
        </div>
      </div>
      <div className="rp-ms-statement-table--container-desktop">
        {renderHeaders()}
        {renderTable(props.data)}
      </div>
      <div className="rp-ms-statement-table--container-mobile">
        <Accordion
          showHandleCollapse={true}
          allowMultipleOpen={true}
          startExpanded={false}
          expandAllChild={null}
        >
          {props.data &&
            props.data.map(item => {
              return (
                <Section
                  identifier={item.invoiceNumber}
                  header={
                    <SectionHeader
                      invoiceDate={item.invoiceDate}
                      invoiceNumber={item.invoiceNumber}
                      dueDate={item.dueDate}
                      amount={item.amount}
                    />
                  }
                  key={item.invoiceNumber}
                >
                  <StatementTableSectionExpandable
                    invoiceNumber={item.invoiceNumber}
                    customerPO={item.customerPO}
                    current={item.current}
                    firstMonthPastDueAmount={item.firstMonthPastDueAmount}
                    secondMonthPastDueAmount={item.secondMonthPastDueAmount}
                    thirdMonthPastDueAmount={item.thirdMonthPastDueAmount}
                  />
                </Section>
              );
            })}
        </Accordion>
        {props.data && props.data.length === 0 && (
          <div className="rp-ms-empty-statement-mobile-container">
            <EmptyStatement />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatementTable;
